/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_7_Access_DescInputs */

const en_privacy_section_7_access_desc = /** @type {(inputs: Privacy_Section_7_Access_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`request a copy of the personal data we hold about you`)
};

const lv_privacy_section_7_access_desc = /** @type {(inputs: Privacy_Section_7_Access_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pieprasīt mūsu glabāto Jūsu personas datu kopiju`)
};

/**
* | output |
* | --- |
* | "request a copy of the personal data we hold about you" |
*
* @param {Privacy_Section_7_Access_DescInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_7_access_desc = /** @type {((inputs?: Privacy_Section_7_Access_DescInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_7_Access_DescInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_7_access_desc(inputs)
	return en_privacy_section_7_access_desc(inputs)
});